// extracted by mini-css-extract-plugin
module.exports = {"button":"IconButton_button__3yS9o","disabled":"IconButton_disabled__EZ3xV"};